/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Tea_Lot_Save_SuccessInputs */

const vi_toast_tea_lot_save_success = /** @type {(inputs: Toast_Tea_Lot_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu lô chè`)
};

/**

* @param {Toast_Tea_Lot_Save_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_tea_lot_save_success = /** @type {((inputs?: Toast_Tea_Lot_Save_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Tea_Lot_Save_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_tea_lot_save_success(inputs)
});